import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";
import { CASE_STUDIES } from "@/data/content";

export default function CaseStudies() {
  return (
    <div data-testid="case-studies-page" className="pt-32 pb-24">
      <Seo
        title="Case Studies"
        description="Selected engagements across MedTech, Private Wealth, Childcare Networks, and Industrial Private Equity."
        path="/case-studies"
      />

      <section className="max-w-[1400px] mx-auto px-6 md:px-12">
        <span className="overline">Engagements</span>
        <h1 className="font-display text-5xl sm:text-7xl text-[#001B54] mt-6 leading-[1.02]">
          Selected
          <span className="italic gold-text"> engagements.</span>
        </h1>
        <p className="text-[#3F4A6B] mt-6 max-w-2xl leading-relaxed">
          Confidential by default. Published only with client consent. Anonymised when discretion requires.
        </p>
      </section>

      <section className="mt-20 max-w-[1400px] mx-auto px-6 md:px-12 space-y-10">
        {CASE_STUDIES.map((c, idx) => (
          <Link
            to={`/case-studies/${c.slug}`}
            key={c.slug}
            data-testid={`case-row-${c.slug}`}
            className="group grid grid-cols-12 gap-6 border-t border-[#001B54]/10 pt-10 hover:border-gold/40 transition-colors"
          >
            <div className="col-span-12 lg:col-span-3">
              <div className="aspect-[4/3] overflow-hidden border border-[#001B54]/10">
                <img src={c.image} alt={c.headline} className="w-full h-full object-cover opacity-65 group-hover:opacity-95 group-hover:scale-105 transition-all duration-1000" />
              </div>
              <div className="text-[0.65rem] tracking-[0.22em] uppercase text-gold/80 mt-3">{c.industry} · {c.duration}</div>
            </div>
            <div className="col-span-12 lg:col-span-7">
              <h2 className="font-display text-3xl sm:text-4xl text-[#001B54] leading-tight">{c.headline}</h2>
              <p className="text-[#3F4A6B] mt-4 max-w-2xl leading-relaxed">{c.summary}</p>
              <div className="mt-6 grid grid-cols-3 gap-6">
                {c.outcomes.map((o) => (
                  <div key={o.label}>
                    <div className="font-display text-3xl gold-text">{o.value}</div>
                    <div className="text-xs text-[#6B7390] mt-1">{o.label}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="hidden lg:flex col-span-2 items-start justify-end">
              <ArrowUpRight size={28} className="text-gold opacity-50 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-500" />
            </div>
          </Link>
        ))}
      </section>

      <section className="mt-24 max-w-[1100px] mx-auto px-6 md:px-12 text-center">
        <h2 className="font-display text-4xl text-[#001B54] leading-tight">Engage AlchamisGroup.</h2>
        <p className="text-[#3F4A6B] mt-4">Each engagement begins with a private briefing.</p>
        <div className="mt-8 flex justify-center gap-4 flex-wrap">
          <Link to="/contact" className="luxury-button">Request a Briefing</Link>
          <Link to="/ai-advisor" className="luxury-button-ghost">Begin Diagnostic</Link>
        </div>
      </section>
    </div>
  );
}
